// export function checkMobile (phone) {
//   return (/^1[0-9]{10}$/.test(phone))
// }
// export function checkNum (num) {
//   // return typeof num === 'number'
//   return (/^\d{n}$/.test(num))
// }
export function before3after4Num (value) {
  if (!value) return ''
  var reg = /^(.{3})(.+)(.{4})$/g
  value = value + ''
  let len = value.length - 7
  if (len < 0) {
    return value
  }
  let str = new Array(len + 1).join('*')
  return value.replace(reg, '$1' + str + '$3')
}
/* 数字 格式化 */
export function numberFormatter (num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num.toString()
}
function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
/**
 *
 * @param {number} time
 * @description 多久之前
 */
export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}
export function money (mo) {
  if (mo) {
    return mo + '' + '￥'
  }
}
export function bankType (type) {
  if (type == 1) {
    return '本行'
  }
  if (type == 2) {
    return '他行'
  }
}
export function jzbbindType (type) {
  if (type == 1) {
    return '个人'
  }
  if (type == 2) {
    return '企业'
  }
}
export function bankTypeStatus (type) {
  if (type == 1) {
    return '待鉴权(请点击去鉴权按钮前往鉴权)'
  }
  if (type == 2) {
    return '已绑定'
  }
}
// export default {checkMobile, checkNum, before3after4Num}



// WEBPACK FOOTER //
// ./src/utils/filter.js